import { render, staticRenderFns } from "./Alerta.vue?vue&type=template&id=55e12428&scoped=true"
import script from "./Alerta.vue?vue&type=script&lang=js"
export * from "./Alerta.vue?vue&type=script&lang=js"
import style0 from "./Alerta.vue?vue&type=style&index=0&id=55e12428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e12428",
  null
  
)

export default component.exports